// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"100":"0f3e663d","276":"0f3e663d","295":"226243de","350":"0f3e663d","543":"0f3e663d","724":"0f3e663d","760":"0f3e663d","943":"226243de","984":"6d63d697"}[chunkId] + ".chunk.css";
};